(function () {
function initVariantButtons() {
var buttons = document.querySelectorAll('.variant-btn');
if (!buttons || buttons.length === 0) return;

var currentPath = window.location.pathname.replace(/\/$/, '');

buttons.forEach(function (button) {
    var url = button.dataset.productUrl;
    if (!url) return;

    // Redirect on click (skip if current page)
    button.addEventListener('click', function () {
    var target = url;
    if (!/^(https?:)?\/\//.test(url)) {
        if (url.charAt(0) !== '/') target = '/' + url;
        target = window.location.origin + target;
    }
    if (target !== window.location.href) {
        window.location.href = target;
    }
    });
});
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initVariantButtons);
} else {
initVariantButtons();
}
})();